/* ============================================================
   CYANOPRINTS — Premium Interactions
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // --- Scroll Progress Bar ---
  const progressBar = document.getElementById('scrollProgress');
  const updateProgress = () => {
    if (!progressBar) return;
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    progressBar.style.width = progress + '%';
  };

  // --- Header Scroll State ---
  const header = document.getElementById('header') || document.querySelector('.cp-header');
  const heroSection = document.querySelector('.cp-hero');

  const updateHeader = () => {
    if (!header) return;
    const scrollY = window.scrollY;
    const heroHeight = heroSection ? heroSection.offsetHeight * 0.4 : 200;

    if (scrollY > heroHeight) {
      header.classList.add('cp-header--scrolled');
    } else {
      header.classList.remove('cp-header--scrolled');
    }
  };

  // Combine scroll handlers
  const onScroll = () => {
    updateProgress();
    updateHeader();
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // --- Mobile Menu ---
  const menuToggle = document.getElementById('menuToggle');
  const mobileMenu = document.getElementById('mobileMenu');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('active');
      document.body.style.overflow = mobileMenu.classList.contains('active') ? 'hidden' : '';
    });

    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
      });
    });
  }

  // --- Intersection Observer for Animations ---
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -60px 0px'
  };

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const rect = entry.target.getBoundingClientRect();
        const delay = Math.max(0, (rect.top - window.innerHeight * 0.3) / 2000);

        setTimeout(() => {
          entry.target.classList.add('cp-visible');
        }, delay * 1000);

        revealObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe all stagger elements
  document.querySelectorAll('.cp-stagger, .cp-reveal').forEach(el => {
    revealObserver.observe(el);
  });

  // Observe hero title separately
  const heroTitle = document.querySelector('.cp-hero__title');
  if (heroTitle) {
    const heroObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('cp-visible');
          heroObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    heroObserver.observe(heroTitle);
  }

  // Auto-trigger hero animations after a short delay
  setTimeout(() => {
    document.querySelectorAll('.cp-hero .cp-reveal').forEach(el => {
      el.classList.add('cp-visible');
    });
    if (heroTitle) heroTitle.classList.add('cp-visible');
  }, 300);

  // --- FAQ Accordion ---
  document.querySelectorAll('.cp-faq__item summary').forEach(summary => {
    summary.addEventListener('click', () => {
      const parent = summary.parentElement;
      document.querySelectorAll('.cp-faq__item').forEach(item => {
        if (item !== parent && item.hasAttribute('open')) {
          item.removeAttribute('open');
        }
      });
    });
  });

  // --- Smooth Scroll ---
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const targetId = anchor.getAttribute('href');
      if (targetId === '#') return;

      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        const headerEl = document.querySelector('header') || document.querySelector('.header');
        const offset = headerEl ? headerEl.offsetHeight + 20 : 80;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  // --- Subtle Card Tilt Effect ---
  document.querySelectorAll('[data-tilt]').forEach(card => {
    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;

      card.style.transform = `
        perspective(800px)
        rotateY(${x * 4}deg)
        rotateX(${-y * 4}deg)
        translateY(-6px)
      `;
    });

    card.addEventListener('mouseleave', () => {
      card.style.transform = '';
    });
  });

  // --- Stagger delay for same-section siblings ---
  document.querySelectorAll('section').forEach(section => {
    const staggers = section.querySelectorAll('.cp-stagger');
    staggers.forEach((el, i) => {
      el.style.transitionDelay = `${i * 0.08}s`;
    });
  });

});
